import { ApolloProvider } from "@apollo/client";
import { Toaster } from "react-hot-toast";
import client from "../../common/apollo-client";
import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import history from "../../common/history";

import "./app.component.scss";
import PrivateRoute from "../../routes/private.routes";
import indexRoutes from "../../routes";
import BlankLayout from "../../layouts/blank.layout";

import { Browser } from "@syncfusion/ej2-base";
import { TYPE_OF_THEME_EXPRESS_ALLIANCE, TYPE_OF_THEME_OCS } from "../../common/constants";

class App extends React.Component {
  componentDidMount(){
    document.title = `${
      window.location.hostname.includes("ocs") === true
        ? "OCS"
        : "Express Alliance"
    } Portaal`;

    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = `${
      window.location.hostname.includes("ocs") === true
        ? TYPE_OF_THEME_OCS
        : TYPE_OF_THEME_EXPRESS_ALLIANCE
    }-favicon.ico`;
  }
  render() {    
    return (
      <div className={Browser.isDevice ? "mobile" : ""}>
        <ApolloProvider client={client}>
          <Toaster position="top-right" containerStyle={{ zIndex: 999999 }} />
          <Router history={history}>
            <Switch>
              <Route exact path="/login" component={BlankLayout} />
              <Route exact path="/forgotpassword" component={BlankLayout} />;
              <Route exact path="/resetpassword" component={BlankLayout} />;
              {indexRoutes.map((prop, key) => {
                return (
                  <PrivateRoute
                    path={prop.path}
                    key={key}
                    component={prop.component}
                  />
                );
              })}
            </Switch>
          </Router>
        </ApolloProvider>
      </div>
    );
  }
}

export default App;
